const EventBus = window.EventBus;
const toUpper = value => (value == null ? '' : String(value).toUpperCase());

export const NewAdvancedSearch = {
  props: [
    'priceInitialRange',
    'minPrice',
    'maxPrice',
    'mileageInitialRange',
    'minMileage',
    'maxMileage',
    'paymentInitialRange',
    'paymentFrequency',
    'carprooflinkInitialRange',
    'minCarprooflink',
    'maxCarprooflink',
    'dryweightInitialRange',
    'minDryweight',
    'maxDryweight',
    'grossweightInitialRange',
    'minGrossweight',
    'maxGrossweight',
    'sleepcapacityInitialRange',
    'minSleepcapacity',
    'maxSleepcapacity',
    'slug',
    'initOpened',
    'initialStocknumber',
    'initialFilter',
    'urlParams',
    'contentdir',
    'gutembergOptions',
    'vehicleFound',
    'packageRegex',
    'sortMakesAlphabetically',
    'collapseDesktop',
    'isUpperBar',
    'locationOrder',
    'defaultOpenSections',
    'showAllOptions',
    'instanceId',
    'language',
  ],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      tags: [],
      payloadtags: [],
      isMobile: false,
      isTablet: false,
      isActive: false,
      filterValue: this.initialFilter,
      searchOpened: false,
      // Filter 7: category icon grid starts collapsed on mobile when the
      // collapseFilterMobile option is on; toggled from the blade template.
      iconGridExpanded: false,
      stockNumber: this.initialStocknumber,
      searchDebounceTimer: null,
      // Seeded with the term that arrived in the URL, so emptying the box on a
      // /filter/<term>/ landing reports the spec's 'clear' ("a cleared inventory
      // search reports element_action: 'clear' ... filter_keyword: null", v2.3
      // §11). Started at '' before, so trackSearchAnalytics() -- which emits the
      // clear only after a tracked search -- stayed silent on exactly the path a
      // shopper takes on sites where Enter navigates to that URL (conformance
      // retest 2026-10-24, captures 19-28). A filter arriving in the URL is active
      // whether or not it was clicked (§3). Re-typing the same term after landing
      // is not a new search, which the last-value guard below already handles.
      lastTrackedSearchValue: this.initialFilter || '',
      priceRange: this.priceInitialRange || [0, 9999999],
      mileageRange: this.mileageInitialRange || [0, 9999999],
      carprooflinkRange: this.carprooflinkInitialRange || [0, 9999999],
      paymentRange: (this.paymentInitialRange && this.paymentInitialRange[0] != null && this.paymentInitialRange[1] != null) ? this.paymentInitialRange : [0, 0],
      dryweightRange: this.dryweightInitialRange || [0, 9999999],
      grossweightRange: this.grossweightInitialRange || [0, 9999999],
      sleepcapacityRange: this.sleepcapacityInitialRange || [0, 999],
      minPayment: 0,
      maxPayment: 0,
      enableCross: false,
      tooltipMerge: false, // true: unifies tooltip boxes false: each box follows de dot range
      urlToGo: '',
      vehiclesCount: 0,
      inStockCount: 0,
      incomingCount: 0,
      filteredInventory: [],
      pivotList: [],
      initialResultset: [],
      loadingInventory: false,
      options: {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        trims: [],
        colours: [],
        bodystyles: [],
        features: [],
        transmissions: [],
        drivetrains: [],
        status: [],
        boxsizes: [],
        enginedisplacements: [],
        packages: [],
        locations: [],
        engines: [],
        types: [],
        subtypes: [],
        productlines: [],
        outsidelengths: [],
        floorplans: [],
        salependings: [],
        certifieds: [],
        specials: [],
        demos: [],
        asiss: [],
        stocks: [],
        lots: [], 
        fueltypes: [],
        seats: [],
      },
      optionsCount: {
        conditions: {},
        years: {},
        makes: {},
        models: {},
        trims: {},
        colours: {},
        bodystyles: {},
        features: {},
        transmissions: {},
        status: {},
        boxsizes: {},
        drivetrains: {},
        enginedisplacements: {},
        packages: {},
        locations: {},
        engines: {},
        types: {},
        subtypes: {},
        productlines: {},
        outsidelengths: {},
        floorplans: {},
        salependings: {},
        demos: {},
        asiss: {},
        certifieds: {},
        specials: {},
        stocks: {},
        lots: {}, 
        fueltypes: {},
        seats: {},
      },
      selected: {
        condition: [],
        year: [],
        make: [],
        model: [],
        trim: [],
        colour: [],
        bodystyle: [],
        feature: [],
        transmission: [],
        drivetrain: [],
        status: [],
        boxsize: [],
        enginedisplacement: [],
        package: [],
        location: [],
        engine: [],
        type: [],
        subtype: [],
        productline: [],
        outsidelength: [],
        floorplan: [],
        salepending: [],
        demo: [],
        asis: [],
        certified: [],
        special: [],
        stock: [],
        lot: [], 
        fueltype: [],
        seats: [],
        tag: [],
      },
      postOptions: {
        models: [],
        trims: [],
        types: [],
        subtypes: []
      },
      aux: {
        trims: []
      },
      pleaseSelectAModel: true,
      pleaseSelectAMake: true,
      initialZero: true,
      lastFilteredOptions: {},
      clearing: false,
      filterSearchDebounceTimer: null,
      pendingFilterSearch: null,
      // LBT-1395 (tester finding 1): suppress lbx_ui_interaction during the initial
      // SRP boot. The chain entryPoint -> updateVehiclesCount -> updateOptions ->
      // buildUrl -> sendFilterOptions debounces flushFilterOptions through a
      // setTimeout(…, 250). Flipping this flag at the end of entryPoint runs BEFORE
      // the timer fires, so the phantom flush still emits. The flag is now flipped
      // inside flushFilterOptions itself, after the first flush, so subsequent
      // user-initiated changes track normally.
      lbxBootDone: false,
      // LBT-1602 (QA 10e): one clear, one report. Set when an empty filter
      // state is announced, cleared again as soon as a selection comes back,
      // so a run of flushes on an unchanged empty state stays quiet.
      lbxClearedReported: false,
      activemodal: null,
      modaltitle: '',
      modalitems: [],
      modalinitialselection: [],
      modalcomponent: '',
      modaloptionscount: {},
    }
  },
  created() {
    if (this.vehicleFound) {
      this.loadingInventory = true;
      window.location.href = this.vehicleFound;
    } else {
      this.httpRequestInventory();
      this.changeClass();
      this.searchOpened = this.initOpened;
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function () {
    // Calls the method before page loads
    this.selected = {
      condition: this.urlParams.conditions || [],
      year: this.urlParams.years || [],
      make: this.urlParams.makes || [],
      lot: this.urlParams.lots || [],
      model: this.urlParams.models || [],
      type: this.urlParams.types || [],
      subtype: this.urlParams.subtypes || [],
      productline: this.urlParams.productlines || [],
      outsidelength: this.urlParams.outsidelengths || [],
      floorplan: this.urlParams.floorplans || [],
      trim: this.urlParams.trims || [],
      colour: this.urlParams.color || [],
      bodystyle: this.urlParams.bodystyles || [],
      transmission: this.urlParams.transmissions || [],
      drivetrain: this.urlParams.drivetrains || [],
      status: this.urlParams.status || [],
      boxsize: this.urlParams.boxsizes || [],
      salepending: this.urlParams.salependings || [],
      stock: this.urlParams.stocks || [],
      enginedisplacement: this.urlParams.enginedisplacements || [],
      package: this.urlParams.package || [],
      engine: this.urlParams.engines || [],
      // LBT-1602 (H8/H9): the URL parser emits `locations`, plural, like every
      // other multi-value facet. This read the singular key, so a location in
      // the URL never reached `selected` on a direct load -- the one facet of
      // 31 that was misaligned. The singular is kept as a fallback in case a
      // caller still passes it.
      location: this.urlParams.locations || this.urlParams.location || [],
      feature: this.urlParams.searchables || [],
      demo: this.urlParams.demos || [],
      asis: this.urlParams.asiss || [],
      certified: this.urlParams.certifieds || [],
      special: this.urlParams.specials || [],
      fueltype: this.urlParams.fueltypes || [],
      seat: this.urlParams.seats || [],
      tag: this.urlParams.tags || [],
    };

    this.initTagsFromSelected();

    // sendFilterOptions is called via entryPoint -> updateVehiclesCount -> updateOptions -> buildUrl
    // No need to call it here in mounted, as it causes a duplicate lbxFilterSearch event fire

    // Listen to instance-specific events if instanceId is provided
    const variablesUpdateEvent = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
    EventBus.$on(variablesUpdateEvent, (variables) => {
      Object.keys(variables).forEach(key => {
        this[key] = variables[key];
      });
    }); 
  },
  methods: {
    openModal: function(component, title) {
      this.activemodal = component;
      this.modaltitle = title;
      this.modalcomponent = component;
      var optionsKey = component + 's';
      if (component === 'feature') optionsKey = 'features';
      if (component === 'enginedisplacement') optionsKey = 'enginedisplacements';
      if (component === 'bodystyle') optionsKey = 'bodystyles';
      if (component === 'fueltype') optionsKey = 'fueltypes';
      if (component === 'drivetrain') optionsKey = 'drivetrains';
      if (component === 'colour') optionsKey = 'colours';
      this.modalitems = this.options[optionsKey] || [];
      this.modalinitialselection = this.selected[component] || [];
      this.modaloptionscount = this.optionsCount[optionsKey] || {};
    },
    closeModal: function() {
      this.activemodal = null;
    },
    updateChecked: function(data) {
      this.selected[data.component] = data.selected;
      this.buildUrl();
    },
    shouldShow() {
      return this.isTablet || this.colapseDesktop;
    },
    getPaymentRange() {
      if (this.filteredInventory) {
        let paymentFrequency = this.paymentFrequency.toLowerCase() || 'biweekly';
    
        // Inicializar con valores extremos para asegurarse de que se actualicen correctamente
        let minPayment = Infinity;
        let maxPayment = -Infinity;
    
        this.filteredInventory.forEach(item => {
          if (item.payments && item.payments[paymentFrequency]) {
            let payment = item.payments[paymentFrequency];
            
            // Comparar para encontrar el valor mínimo y máximo
            if (payment < minPayment) {
              minPayment = payment;
            }
            if (payment > maxPayment) {
              maxPayment = payment;
            }
          }
        });
    
        // Asignar los valores nuevos de rango
        if(minPayment != Infinity && maxPayment != -Infinity) {
          this.minPayment = minPayment;
          this.maxPayment = maxPayment;

          if(this.paymentInitialRange && ((this.paymentInitialRange[0] === null && this.paymentInitialRange[1] === null) || (this.paymentInitialRange[0] === 0 && this.paymentInitialRange[1] === 0))){
            this.paymentRange = [minPayment, maxPayment];
          }
          else{
            this.paymentRange = this.paymentInitialRange;
          }
        }
      }
    },       
    moreThanZero(array) {
      return array.length > 0;
    },
    changeClass() {
      setTimeout(() => this.isActive = true, 100)
    },
    httpRequestInventory() {
      this.loadingInventory = true;
      EventBus.httpRequestInventory(this.contentdir, this.entryPoint, this.gutembergOptions);
    },
    entryPoint(inventory) {
      this.initialResultset = inventory;
      this.loadingInventory = false;
      this.options = this.getOptions(this.initialResultset);
      this.resolveSelectedSlugs();
      if (inventory && inventory.length <= 0) {
        this.searchOpened = false;
      }
      this.updateVehiclesCount();

      // LBT-1395 / LBT-1603: report the initial filter state and result count.
      // Fires lbx_srp_ready, but only if the applied filters already match what
      // the URL asked for — resolveSelectedSlugs() ran inside entryPoint above,
      // yet some dimensions (location in particular) land a beat later. Whichever
      // flush converges is the one that emits; see the call in
      // flushFilterOptions.
      if (window.LBX && window.LBX.track && typeof window.LBX.track.srpReady === 'function') {
        //
        // A filtered length of 0 is a real count. This used to read
        // `(filtered && filtered.length) || inventory.length`, so a URL filter
        // the dealer cannot satisfy -- /new-vehicles/make/honda/ at a Cadillac
        // store -- fell through the `||` to the UNFILTERED total: lbx_srp_ready
        // reported filter_make 'honda' with srp_total_results 18 while the page
        // showed "0 Vehicles" (conformance audit, 2026-10-22). The spec is
        // explicit that a filter resolving to zero results is settled with a
        // count of zero, so the fallback is reserved for the one case where the
        // filtered list does not exist yet.
        const initialCount = Array.isArray(this.filteredInventory)
          ? this.filteredInventory.length
          : (inventory ? inventory.length : 0);
        window.LBX.track.srpReady(this.lbxFilterState(), initialCount);
      }
      // lbxBootDone is intentionally flipped inside flushFilterOptions, not here.
      // See the data() comment for the rationale.
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.refreshSliders();
    },
    toggleAdvancedSearch() {
      this.searchOpened = !this.searchOpened;

       this.$nextTick(() => {
        this.refreshSliders();
      });
    },
    toggleIconGrid() {
      this.iconGridExpanded = !this.iconGridExpanded;

      // Sliders hidden behind the mobile collapse mount with a 0-width rail;
      // refresh once revealed so the dots position correctly.
      this.$nextTick(() => {
        this.refreshSliders();
      });
    },
    clearOptions() {
      var options = {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        trims: [],
        colours: [],
        bodystyles: [],
        features: [],
        transmissions: [],
        status: [],
        boxsizes: [],
        drivetrains: [],
        enginedisplacements: [],
        packages: [],
        locations: [],
        engines: [],
        types: [],
        subtypes: [],
        productlines: [],
        outsidelengths: [],
        floorplans: [],
        salependings: [],
        demos: [],
        asiss: [],
        certifieds: [],
        specials: [],
        stocks: [],
        lots: [],
        fueltypes: [],
        seats: [],
      }
      return options;
    },
    clearSelected() {
      return {
        condition: [],
        year: [],
        make: [],
        lot: [],
        model: [],
        type: [],
        subtype: [],
        productline: [],
        outsidelength: [],
        floorplan: [],
        trim: [],
        colour: [],
        bodystyle: [],
        transmission: [],
        drivetrain: [],
        status: [],
        boxsize: [],
        salepending: [],
        stock: [],
        enginedisplacement: [],
        package: [],
        engine: [],
        location: [],
        feature: [],
        demo: [],
        asis: [],
        certified: [],
        special: [],
        fueltype: [],
        seat: [],
        tag: [],
      };
    },
    initTagsFromSelected() {
      this.tags = [];
      this.payloadtags = [];
      Object.keys(this.selected).forEach(key => {
        const value = this.selected[key];
        if (Array.isArray(value) && value.length > 0) {
          value.forEach(item => {
            // Check if it's not already in tags (lowercase compare to be safe)
            const exists = this.tags.some(t => t.toLowerCase() === item.toLowerCase());
            if (!exists) {
              this.tags.push(item);
              this.payloadtags.push({
                component: key,
                selected: item,
                status: true
              });
            }
          });
        }
      });
      // Also check ranges
      this.validatePriceRange();
    },
    /**
     * Filter state as the dataLayer should report it.
     *
     * LBT-1602 (M4): filter_condition was always null, even on a new-inventory
     * SRP, which left a new SRP indistinguishable from a used one in reporting.
     * The reason is that the new/used split is not a URL facet at all -- it is
     * the inventory block's `status` attribute -- so `selected.condition` is
     * legitimately empty until the user touches the condition filter.
     *
     * The Phase 1 `lbxFilterSearch` event already reported the block status as
     * the condition (see the pushes below); v2 lost that. This restores it.
     *
     * Returns a copy on purpose: writing to this.selected would change what
     * actually gets filtered, not just what gets reported.
     */
    lbxFilterState() {
      const state = Object.assign({}, this.selected);
      const hasUserCondition = state.condition && state.condition.length > 0;

      if (!hasUserCondition && this.gutembergOptions) {
        // A block states its scope through TWO different options, and the demo
        // case uses the one this originally missed:
        //
        //   status → a feed condition:      'New' / 'Used'        ('all'  = unscoped)
        //   flags  → a merchandising set:   'certified' / 'demo'  ('none' = unscoped)
        //
        // A demo page carries status 'all' WITH flags 'demo' — verified on
        // renfrewchrysler.com and reproduced locally — so reading status alone
        // reported filter_condition null on a page that is nothing but demos
        // (LBT-1603, F2). A CPO page is the same defect one value over, and is
        // fixed by the same line.
        //
        // flags is checked first because it is the more specific of the two, and
        // both only ever emit a value the vehicle_condition enum accepts: a block
        // scoped to anything else reports null rather than inventing a condition.
        const flags = String(this.gutembergOptions.flags || '').toLowerCase();
        const status = String(this.gutembergOptions.status || '').toLowerCase();

        const scoped = (flags === 'certified' || flags === 'demo')
          ? flags
          : ((status === 'new' || status === 'used' || status === 'demo') ? status : null);

        if (scoped) {
          state.condition = [scoped];
        }
      }

      // The keyword search is not part of `selected` — it is its own input,
      // matched as a superstring rather than as a facet — so it has to be
      // carried explicitly for filter_keyword to exist (LBT-1603, Q3). Sent raw
      // and unformatted: normalizing, capping and dropping PII all happen in
      // one place, next to the other filter_* fields.
      state.filterValue = this.filterValue;

      return state;
    },
    resolveSelectedSlugs() {
      const keysToResolve = [
        { selected: 'condition', options: 'conditions' },
        { selected: 'year', options: 'years' },
        { selected: 'make', options: 'makes' },
        { selected: 'model', options: 'models' },
        { selected: 'trim', options: 'trims' },
        { selected: 'colour', options: 'colours' },
        { selected: 'bodystyle', options: 'bodystyles' },
        { selected: 'transmission', options: 'transmissions' },
        { selected: 'drivetrain', options: 'drivetrains' },
        { selected: 'fueltype', options: 'fueltypes' },
        { selected: 'enginedisplacement', options: 'enginedisplacements' },
        { selected: 'feature', options: 'features' },
        { selected: 'status', options: 'status' },
        { selected: 'package', options: 'packages' },
        { selected: 'seat', options: 'seats' },
        { selected: 'location', options: 'locations' },
        { selected: 'engine', options: 'engines' },
        { selected: 'boxsize', options: 'boxsizes' }
      ];

      keysToResolve.forEach(mapping => {
        const selectedValues = this.selected[mapping.selected];
        const availableOptions = this.options[mapping.options];
        
        if (selectedValues && selectedValues.length > 0 && availableOptions && availableOptions.length > 0) {
          const resolved = selectedValues.map(val => {
            // If the value is already in availableOptions (exact match), keep it
            if (availableOptions.includes(val)) return val;
            
            // Otherwise, try to find an option that, when slugified, matches the selected value
            const match = availableOptions.find(opt => {
              const slug = opt.toString().toLowerCase()
                         .replace(/ /g, '-')
                         .replace(/-{2,}/g, '-')
                         .replace(/[^a-z0-9-]/g, '');
              const normalizedVal = val.toLowerCase().replace(/[^a-z0-9-]/g, '');
              return slug === normalizedVal || slug.replace(/-/g, '') === normalizedVal;
            });
            
            return match || val;
          });
          
          this.selected[mapping.selected] = resolved;
        }
      });
      
      this.initTagsFromSelected();
    },
    getOptions(inventory) {
      // clear all options
      var options = {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        trims: [],
        colours: [],
        bodystyles: [],
        features: [],
        transmissions: [],
        status: [],
        boxsizes: [],
        drivetrains: [],
        enginedisplacements: [],
        packages: [],
        locations: [],
        engines: [],
        types: [],
        subtypes: [],
        productlines: [],
        outsidelengths: [],
        floorplans: [],
        salependings: [],
        demos: [],
        asiss: [],
        certifieds: [],
        specials: [],
        stocks: [],
        lots: [],
        fueltypes: [],
        seats: [],
      }

      // Reset optionsCount to prevent accumulation
      this.optionsCount = {
        conditions: {},
        years: {},
        makes: {},
        models: {},
        trims: {},
        colours: {},
        bodystyles: {},
        features: {},
        transmissions: {},
        status: {},
        boxsizes: {},
        drivetrains: {},
        enginedisplacements: {},
        packages: {},
        locations: {},
        engines: {},
        types: {},
        subtypes: {},
        productlines: {},
        outsidelengths: {},
        floorplans: {},
        salependings: {},
        demos: {},
        asiss: {},
        certifieds: {},
        specials: {},
        stocks: {},
        lots: {},
        fueltypes: {},
        seats: {},
      };

      // Reset stock counts to prevent accumulation
      this.inStockCount = 0;
      this.incomingCount = 0;

      Object.values(inventory).forEach(item => {
        // Calculate condition counts
        if (item.condition) {
          if (!options.conditions.includes(item.condition)) {
            options.conditions.push(item.condition);
            this.optionsCount.conditions[item.condition] = 1;
          } else {
            this.optionsCount.conditions[item.condition]++;
          }
        }
      });

      Object.values(inventory).forEach(item => {
        if (item.year && !options.years.includes(item.year)) {
          options.years.push(item.year)
          this.optionsCount.years[item.year] = 1;
        }
        else {
          this.optionsCount.years[item.year]++;
        }

        if (item.salepending) {
          if (!options.salependings.includes("1")) {
            options.salependings.push("1")
            this.optionsCount.salependings["1"] = 1;
          } else {
            this.optionsCount.salependings["1"]++;
          }
        }

        if (!item.salepending) {
          if (!options.salependings.includes("0")) {
            options.salependings.push("0")
            this.optionsCount.salependings["0"] = 1;
          } else {
            this.optionsCount.salependings["0"]++;
          }
        }

        if (item.demo) {
          if (!options.demos.includes("1")) {
            options.demos.push("1")
            this.optionsCount.demos["1"] = 1;
          } else {
            this.optionsCount.demos["1"]++;
          }
        }

        if (item.asis) {
          if (!options.asiss.includes("1")) {
            options.asiss.push("1")
            this.optionsCount.asiss["1"] = 1;
          } else {
            this.optionsCount.asiss["1"]++;
          }
        }

        if (item.certified) {
          if (!options.certifieds.includes("1")) {
            options.certifieds.push("1")
            this.optionsCount.certifieds["1"] = 1;
          } else {
            this.optionsCount.certifieds["1"]++;
          }
        }

        if (item.special) {
          if (!options.specials.includes("1")) {
            options.specials.push("1")
            this.optionsCount.specials["1"] = 1;
          } else {
            this.optionsCount.specials["1"]++;
          }
        }

        if(item.seats && item.seats > 0){
          if (!options.seats.includes(item.seats.toString())) {
            options.seats.push(item.seats.toString())
            this.optionsCount.seats[item.seats.toString()] = 1;
          }
          else {
            this.optionsCount.seats[item.seats.toString()]++;
          }
        }

        if (item.stocknumber && !options.stocks.includes(item.stock)) {
          options.stocks.push(item.stocknumber)
          this.optionsCount.stocks[item.stocknumber] = 1;
        }
        else {
          this.optionsCount.stocks[item.stocknumber]++;
        }


        if (item.make && !options.makes.includes(toUpper(item.make))) {
          options.makes.push(toUpper(item.make))
          this.optionsCount.makes[toUpper(item.make)] = 1;
        }
        else if (item.make)
          this.optionsCount.makes[toUpper(item.make)]++;


        if (item.lot && !options.lots.includes(toUpper(item.lot))) {
          options.lots.push(toUpper(item.lot))
          this.optionsCount.lots[toUpper(item.lot)] = 1;
        }
        else if (item.lot)
          this.optionsCount.lots[toUpper(item.lot)]++;

        if (item.model && !options.models.includes(toUpper(item.model))) {
          options.models.push(toUpper(item.model))
          this.optionsCount.models[toUpper(item.model)] = 1;
        }
        else if (item.model)
          this.optionsCount.models[toUpper(item.model)]++;

        if (item.trim && !options.trims.includes(toUpper(item.trim))) {
          options.trims.push(toUpper(item.trim))
          this.optionsCount.trims[toUpper(item.trim)] = 1;
        }
        else if (item.trim)
          this.optionsCount.trims[toUpper(item.trim)]++;

        const colour = typeof item.exteriorcolor === 'string' ? item.exteriorcolor.toUpperCase() : '';
        if (colour && !options.colours.includes(colour)) {
          options.colours.push(colour)
          this.optionsCount.colours[colour] = 1;
        }
        else if (colour)
          this.optionsCount.colours[colour]++;

        if (item.bodystyle && !options.bodystyles.includes(item.bodystyle)) {
          options.bodystyles.push(item.bodystyle)
          this.optionsCount.bodystyles[item.bodystyle] = 1;
        }
        else if (item.bodystyle)
          this.optionsCount.bodystyles[item.bodystyle]++;


        if (item.fueltype && !options.fueltypes.includes(toUpper(item.fueltype))) {
          options.fueltypes.push(toUpper(item.fueltype))
          this.optionsCount.fueltypes[toUpper(item.fueltype)] = 1;
        }
        else if (item.fueltype)
          this.optionsCount.fueltypes[toUpper(item.fueltype)]++;


        if (item.transmission && !options.transmissions.includes(item.transmission)) {
          options.transmissions.push(item.transmission)
          this.optionsCount.transmissions[item.transmission] = 1;
        }
        else {
          this.optionsCount.transmissions[item.transmission]++;
        }

        if (item.drivetrain && !options.drivetrains.includes(toUpper(item.drivetrain))) {
          options.drivetrains.push(toUpper(item.drivetrain))
          this.optionsCount.drivetrains[toUpper(item.drivetrain)] = 1;
        }
        else if (item.drivetrain)
          this.optionsCount.drivetrains[toUpper(item.drivetrain)]++;

        if (item.boxsize && !options.boxsizes.includes(toUpper(item.boxsize))) {
          options.boxsizes.push(toUpper(item.boxsize))
          this.optionsCount.boxsizes[toUpper(item.boxsize)] = 1;
        }
        else if (item.boxsize)
          this.optionsCount.boxsizes[toUpper(item.boxsize)]++;

        if (item.location && !options.locations.includes(toUpper(item.location))) {
          options.locations.push(toUpper(item.location))
          this.optionsCount.locations[toUpper(item.location)] = 1;
        }
        else if (item.location)
          this.optionsCount.locations[toUpper(item.location)]++;

        if (item.engine && !options.engines.includes(toUpper(item.engine))) {
          options.engines.push(toUpper(item.engine))
          this.optionsCount.engines[toUpper(item.engine)] = 1;
        }
        else if (item.engine)
          this.optionsCount.engines[toUpper(item.engine)]++;

        /*----------- STATUS FILTER ------------------  */

        if (item.incoming) {
          if (!options.status.includes("INCOMING")) {
            options.status.push("INCOMING")
            this.optionsCount.status["INCOMING"] = 1;
            this.incomingCount = 1;
          } else {
            this.optionsCount.status["INCOMING"]++;
            this.incomingCount++;
          }
        }

        if (!item.incoming) {
          if (!options.status.includes("IN STOCK")) {
            options.status.push("IN STOCK")
            this.optionsCount.status["IN STOCK"] = 1;
            this.inStockCount = 1;
          } else {
            this.optionsCount.status["IN STOCK"]++;
            this.inStockCount++;
          }
        }

        if (item.special) {
          if (!options.status.includes("SPECIAL")) {
            options.status.push("SPECIAL")
            this.optionsCount.status["SPECIAL"] = 1;
          } else {
            this.optionsCount.status["SPECIAL"]++;
          }
        }

        if (item.demo) {
          if (!options.status.includes("DEMO")) {
            options.status.push("DEMO")
            this.optionsCount.status["DEMO"] = 1;
          } else {
            this.optionsCount.status["DEMO"]++;
          }
        }

        if (item.asis) {
          if (!options.status.includes("AS IS")) {
            options.status.push("AS IS")
            this.optionsCount.status["AS IS"] = 1;
          } else {
            this.optionsCount.status["AS IS"]++;
          }
        }

        if (item.salepending) {
          if (!options.status.includes("SALE PENDING")) {
            options.status.push("SALE PENDING")
            this.optionsCount.status["SALE PENDING"] = 1;
          } else {
            this.optionsCount.status["SALE PENDING"]++;
          }
        }

        if (item.certified) {
          if (!options.status.includes("CERTIFIED")) {
            options.status.push("CERTIFIED")
            this.optionsCount.status["CERTIFIED"] = 1;
          } else {
            this.optionsCount.status["CERTIFIED"]++;
          }
        }

        /* ------- END STATUS FILTER ------------------- */

        if (item.enginedisplacement && !options.enginedisplacements.includes(item.enginedisplacement.toString())) {
          options.enginedisplacements.push(item.enginedisplacement.toString())
          this.optionsCount.enginedisplacements[item.enginedisplacement] = 1;
        }
        else {
          this.optionsCount.enginedisplacements[item.enginedisplacement]++;
        }
        if (item.type && !options.types.includes(item.type)) {
          options.types.push(item.type)
          this.optionsCount.types[item.type] = 1
        }
        else {
          this.optionsCount.types[item.type]++;
        }
        if (item.subtype && !options.subtypes.includes(item.subtype)) {
          options.subtypes.push(item.subtype)
          this.optionsCount.subtypes[item.subtype] = 1
        }
        else {
          this.optionsCount.subtypes[item.subtype]++;
        }
        if (item.productline && !options.productlines.includes(item.productline)) {
          options.productlines.push(item.productline)
          this.optionsCount.productlines[item.productline] = 1
        }
        else {
          this.optionsCount.productlines[item.productline]++;
        }
        if (item.outsidelength) {
          if (item.outsidelength && !options.outsidelengths.includes(item.outsidelength)) {
            options.outsidelengths.push(item.outsidelength)
            this.optionsCount.outsidelengths[item.outsidelength] = 1
          }
          else {
            this.optionsCount.outsidelengths[item.outsidelength]++;
          }
        }
        if (item.floorplantags) {
          var search = item.floorplantags
          for (var i in search) {
            if (!options.floorplans.includes(search[i])) {
              options.floorplans.push(search[i])
              this.optionsCount.floorplans[search[i]] = 1;
            }
            else {
              this.optionsCount.floorplans[search[i]]++;
            }
          }
        }
        let searchableArrAlreadyIterated = [];
        for (var k in item.searchablesarray) {
          if (!options.features.includes(item.searchablesarray[k])) {
            options.features.push(item.searchablesarray[k])
            this.optionsCount.features[item.searchablesarray[k]] = 1;
          }
          else {
            if (!searchableArrAlreadyIterated.includes(item.searchablesarray[k]))
              this.optionsCount.features[item.searchablesarray[k]]++;
          }
          searchableArrAlreadyIterated.push(item.searchablesarray[k]);
        }
        if (typeof item.searchables !== "undefined" && item.searchables.length > 0) {
          var searchablesExploded = item.searchables.split(',');
          var regex = new RegExp(this.packageRegex);
          for (var j in searchablesExploded) {
            if (searchablesExploded[j].match(regex) && !options.packages.includes(searchablesExploded[j])) {
              options.packages.push(searchablesExploded[j])
              this.optionsCount.packages[searchablesExploded[j]] = 1;
            }
            else if (searchablesExploded[j].match(regex) && options.packages.includes(searchablesExploded[j]))
              this.optionsCount.packages[searchablesExploded[j]]++
          }

        }
      })

      options.conditions.sort();
      options.years.sort().reverse();
      options.salependings.sort();
      options.demos.sort();
      options.asiss.sort();
      options.certifieds.sort();
      options.specials.sort();
      options.stocks.sort();

      if(this.sortMakesAlphabetically){
        options.makes.sort();
      }else{
        if (options.makes.length > 0) {
          var listMakes = this.optionsCount.makes;
          options.makes.sort(function (a, b) {
            return (listMakes[a] < listMakes[b]) ? 1 : ((listMakes[a] > listMakes[b]) ? -1 : ((a > b) ? 1 : ((a < b) ? -1 : 0)));
          });
        }
      }

      /* Sorting locations by specific order */
      if(this.locationOrder && this.locationOrder.length > 0){
        const orderLC = this.locationOrder.map(s => s.trim().toLowerCase());

        const rank = new Map(orderLC.map((v, i) => [v, i]));

        options.locations.sort((a, b) => {
          const ia = rank.has(a.toLowerCase()) ? rank.get(a.toLowerCase()) : Infinity;
          const ib = rank.has(b.toLowerCase()) ? rank.get(b.toLowerCase()) : Infinity;

          if (ia !== ib) return ia - ib;
          return a.localeCompare(b);
        });

      }else{
        options.locations.sort();
      }

      options.lots.sort();
      options.models.sort();
      options.trims.sort();
      options.colours.sort();
      options.bodystyles.sort();
      options.features.sort();
      options.transmissions.sort();
      options.status.sort();
      options.drivetrains.sort();
      options.boxsizes.sort();
      options.enginedisplacements.sort();
      options.packages.sort();
      options.types.sort();
      options.subtypes.sort();
      options.productlines.sort();
      options.outsidelengths.sort();
      options.floorplans.sort();
      options.engines.sort();
      options.fueltypes.sort();
      options.seats.sort();

      // For pivoted (selected) categories, keep the BROAD options list so the
      // facet does not collapse to just the currently-matching values when one
      // is selected — the user must still see/pick/unpick the others, including
      // zero-count ones.
      if (!this.lastOptions) this.lastOptions = {};
      this.pivotList.forEach(item => {
        if (this.options[item] && this.options[item].length) {
          // Normal flow: reuse the previous (broad) list.
          options[item] = this.options[item];
        } else if (this.lastOptions[item] && this.lastOptions[item].length) {
          // Recovery after a zero-result state: clearOptions() emptied
          // this.options[item], so the previous broad list is gone. Restore it
          // from the last non-empty snapshot instead of falling back to the
          // freshly-computed (narrow) list — otherwise every option with no
          // vehicle under the current selection (count 0) silently disappears
          // and can no longer be unpicked. (LBT-1461 round 2 follow-up.)
          options[item] = this.lastOptions[item].slice();
        }

        // ...and a pivoted facet must ALWAYS expose its currently-selected
        // values, otherwise the matching control has no row to render as active
        // even though the value is selected. The vertical "Popular Features"
        // group renders strictly from options.features (no fallback), while the
        // horizontal bar keeps its own retained chip list — so when two
        // mutually-exclusive features are selected (zero results) and one is
        // removed, the preserved (now stale) option set of the removed feature
        // omits the remaining one, leaving the vertical checkbox unmarked while
        // the bar shows it. Union the selected values back in to stay in sync.
        // (LBT-1461 round 2 — Scenario 3.)
        var selectedKey = item.replace(/s$/, "");
        var selectedValues = this.selected[selectedKey];
        if (Array.isArray(options[item]) && Array.isArray(selectedValues)) {
          selectedValues.forEach(function (value) {
            if (!options[item].includes(value)) options[item].push(value);
          });
        }
      })

      // Snapshot the (broad) option lists so they survive a later zero-result
      // clearOptions() and can be restored above. Only non-empty lists are
      // cached, so a transient empty state never overwrites a good snapshot.
      // (LBT-1461 round 2 follow-up.)
      Object.keys(options).forEach((key) => {
        if (Array.isArray(options[key]) && options[key].length) {
          this.lastOptions[key] = options[key].slice();
        }
      });

      return options;
    },
    buildUrl(keepSort = true) {
      let url = '';

      if (this.stockNumber) {
        url += '/stocknumber/' + this.stockNumber;
      }

      if (this.priceRange) {
        // Compare rounded to whole numbers: the min/max props and the range prop are
        // serialized by different PHP paths, so a raw != on floats is a false positive
        // and injects a phantom /price/ into the URL on load. Round the written values
        // too so a decimal price never lands in a permalink.
        const priceIsDefault = Math.round(this.priceRange[0]) === Math.round(this.minPrice) &&
          Math.round(this.priceRange[1]) === Math.round(this.maxPrice);
        if (!priceIsDefault)
          url += '/price/' + Math.round(this.priceRange[0]) + '-' + Math.round(this.priceRange[1]);
      }

      if (this.carprooflinkRange) {
        const towingIsDefault = Math.round(this.carprooflinkRange[0]) === Math.round(this.minCarprooflink) &&
          Math.round(this.carprooflinkRange[1]) === Math.round(this.maxCarprooflink);
        if (!towingIsDefault)
          url += '/towing/' + Math.round(this.carprooflinkRange[0]) + '-' + Math.round(this.carprooflinkRange[1]);
      }

      if (this.paymentRange) {
        if(this.minPayment != 0 && this.maxPayment != 0 && this.paymentRange[0] != 0 && this.paymentRange[1] != 0) {
          const paymentIsDefault = Math.round(this.paymentRange[0]) === Math.round(this.minPayment) &&
            Math.round(this.paymentRange[1]) === Math.round(this.maxPayment);
          if (!paymentIsDefault)
            url += '/payment/' + Math.round(this.paymentRange[0]) + '-' + Math.round(this.paymentRange[1]);
        }
      }

      if (this.mileageRange) {
        const mileageIsDefault = Math.round(this.mileageRange[0]) === Math.round(this.minMileage) &&
          Math.round(this.mileageRange[1]) === Math.round(this.maxMileage);
        if (!mileageIsDefault)
          url += '/mileage/' + Math.round(this.mileageRange[0]) + '-' + Math.round(this.mileageRange[1]);
      }

      if (this.dryweightRange) {
        if (this.minDryweight >= 0 && this.dryweightRange && this.dryweightRange[0] >= 0 && this.maxDryweight
          && this.dryweightRange[1] >= 0 && (Math.round(this.dryweightRange[0]) > Math.round(this.minDryweight) || Math.round(this.dryweightRange[1]) < Math.round(this.maxDryweight))) {
          url += '/dryweight/' + Math.round(this.dryweightRange[0]) + '-' + Math.round(this.dryweightRange[1]);
        }
      }

      if (this.grossweightRange) {
        if (this.minGrossweight >= 0 && this.grossweightRange && this.grossweightRange[0] >= 0 && this.maxGrossweight
          && this.grossweightRange[1] >= 0 && (Math.round(this.grossweightRange[0]) > Math.round(this.minGrossweight) || Math.round(this.grossweightRange[1]) < Math.round(this.maxGrossweight))) {
          url += '/grossweight/' + Math.round(this.grossweightRange[0]) + '-' + Math.round(this.grossweightRange[1]);
        }
      }

      if (this.sleepcapacityRange) {
        if (this.minSleepcapacity >= 0 && this.sleepcapacityRange && this.sleepcapacityRange[0] >= 0 && this.maxSleepcapacity
          && this.sleepcapacityRange[1] >= 0 && (this.sleepcapacityRange[0] > this.minSleepcapacity || this.sleepcapacityRange[1] < this.maxSleepcapacity)) {
          url += '/sleepcapacity/' + this.sleepcapacityRange[0] + '-' + this.sleepcapacityRange[1];
        }
      }

      if (this.selected.condition.length > 0)
        url += '/condition/' + this.selected.condition.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.year.length > 0)
        url += '/year/' + this.selected.year.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.salepending.length > 0)
        url += '/salepending/' + this.selected.salepending.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.demo.length > 0)
        url += '/demo';
      if (this.selected.stock.length > 0)
        url += '/stock/' + this.selected.stock.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.make.length > 0)
        url += '/make/' + this.selected.make.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.lot.length > 0)
        url += '/lot/' + this.selected.lot.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.type.length > 0)
        url += '/type/' + this.selected.type.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.subtype.length > 0)
        url += '/subtype/' + this.selected.subtype.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.model.length > 0)
        url += '/model/' + this.selected.model.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.trim.length > 0)
        url += '/trim/' + this.selected.trim.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.transmission.length > 0)
        url += '/transmission/' + this.selected.transmission.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');

      if (this.selected.status.length > 0)
        url += '/status/' + this.selected.status.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');

      if (this.selected.drivetrain.length > 0)
        url += '/drivetrain/' + this.selected.drivetrain.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.boxsize.length > 0)
        url += '/boxsize/' + this.selected.boxsize.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').replace(/'/g, '[inch]').replace(/[/]/g, "_").toLowerCase()
      }).join(',');
      if (this.selected.enginedisplacement.length > 0)
        url += '/enginedisplacement/' + this.selected.enginedisplacement.map((item) => {
          return item.toString().replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.package.length > 0)
        url += '/package/' + this.selected.package.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.location.length > 0)
        url += '/location/' + this.selected.location.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.engine.length > 0)
        url += '/engine/' + this.selected.engine.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').replace(/®/g, '[reg]').replace(/–/g, '[-]').replace(/&/g, '[AND]').replace(/[/]/g, "_").replace(/\(/g, '[').replace(/\)/g, ']').replace(/\+/g, 'plus').replace(/\u00A0/g, '[x]').toLowerCase()
      }).join(',');
      if (this.selected.colour.length > 0)
        url += '/exteriorcolor/' + this.selected.colour.map((item) => {
          return encodeURIComponent(item.replace(/ /g, '-').replace(/-{2,}/g, '-').replace(/[/]/g, "_").replace(/\(/g, '[').replace(/\)/g, ']').toLowerCase())
      }).join(',');
      if (this.selected.bodystyle.length > 0)
        url += '/bodystyle/' + this.selected.bodystyle.map((item) => {
          return item.replace(/[ ,]/g, '-').replace(/-{2,}/g, '-').replace(/[/]/g, "_").replace(/\(/g, '[').replace(/\)/g, ']').replace(/'/g, '%27').toLowerCase()
        }).join(',');
      if (this.selected.fueltype.length > 0)
        url += '/fueltype/' + this.selected.fueltype.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.filterValue && this.filterValue.length > 0){
        url += '/filter/' + this.filterValue.trim().replace(/ /g, '_').toLowerCase();
      }
      if (this.selected.feature.length > 0)
        url += '/option/' + this.selected.feature.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.productline.length > 0)
        url += '/productline/' + this.selected.productline.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');

      if (this.selected.outsidelength.length > 0)
        url += '/length/' + this.selected.outsidelength.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.floorplan.length > 0)
        url += '/floorplan/' + this.selected.floorplan.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');

      if (this.selected.special.length > 0)
        url += '/special/' + this.selected.special[0];

      if (this.selected.certified.length > 0)
        url += '/certified/' + this.selected.certified[0];

      if (this.selected.seat.length > 0)
        url += '/seat/' + this.selected.seat.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toString().toLowerCase()
        }).join(',');

      if (this.selected.tag.length > 0)
        url += '/tags/' + this.selected.tag.map((item) => {
          return item.replace(/ /g, '_').toLowerCase()
        }).join(',');

      // SHIFT DIGITAL EVENTS
      if (document.getElementById("shiftdigital-script") != null) {
        if (this.selected.condition.length > 0 || 
            this.selected.year.length > 0 || 
            this.selected.make.length > 0 ||
            this.selected.model.length > 0 || 
            this.selected.trim.length > 0 ||
            this.selected.drivetrain.length > 0 || 
            this.selected.boxsize.length > 0 || 
            this.selected.colour.length > 0 || 
            this.selected.bodystyle.length > 0 || 
            this.selected.fueltype.length > 0 ||
            this.selected.feature.length > 0 ||
            (this.minPrice != this.priceRange[0] || this.maxPrice != this.priceRange[1]) ||
            (this.minMileage != this.mileageRange[0] || this.maxMileage != this.mileageRange[1]) ) {

          if (!sessionStorage.getItem('formEventts') || (Date.now() - sessionStorage.getItem('formEventts')) / 1000 > 2) {
            sessionStorage.setItem('formEventts', new Date().getTime());

            var statusLB = '';
            if (this.gutembergOptions && this.gutembergOptions.flags && this.gutembergOptions.flags == 'certified') {
              statusLB = 'CPO';
            }else if (this.gutembergOptions && this.gutembergOptions.status && this.gutembergOptions.status == 'New') {
              statusLB = 'New';
            }else if (this.selected.condition && this.selected.condition.length > 0 && this.selected.condition.includes('NEW')) {
              statusLB = 'New';
            } else if(this.gutembergOptions.status && this.gutembergOptions.status == 'Used' && this.searchStatusInInventory('certified') <= 0){
              statusLB = 'Used';
            }else {
              statusLB = 'Mixed';
            }

            let modelFilter = (this.selected.model.length > 0) ? this.selected.model.map((item) => {return item.toLowerCase()}).join('|') : 'all';

            setTimeout(() => {
              sendPvVl();
              sd('dataLayer', {
                countSearchResults: this.vehiclesCount,
                filterSearch: {
                  status: statusLB,
                  year: this.selected.year,
                  make: this.selected.make,
                  model: modelFilter,
                  trim: this.selected.trim,
                  color: this.selected.colour,
                  driveTrain: this.selected.drivetrain,
                  boxsize: this.selected.boxsize,
                  minPrice: this.priceRange[0],
                  maxPrice: this.priceRange[1],
                  bodyStyle: this.selected.bodystyle,
                  features: this.selected.feature,
                  fueltype: this.selected.fueltype
                },
                events: 'filterSearch'
              });
              sd('send');
            }, 300);

          }
        }
      }

      url += '/';
      var pathname = window.location.pathname;
      var query = window.location.search || '';
      pathname = this.clearParameters(pathname, keepSort);
      const path = (pathname + url).replace('//', '/');

      if(!this.clearing && !this.isUpperBar){
        this.sendFilterOptions(window.location.origin + path + query);
      }
      
      this.urlToGo = (pathname + url).replace('//', '/') + query;

    },
    sendFilterOptions(fullUrl){
      // Encolamos el "último estado deseado" y debouncemos el push al dataLayer.
      // Durante la carga inicial, los toggle lists hijos se reconcilian en
      // cascada (ej. makeChanged limpia temporalmente el model, el toggle list
      // del model lo vuelve a poner como el nombre real del inventario). Sin
      // debounce esto produce múltiples eventos lbxFilterSearch en el refresh.
      // Con debounce solo se empuja el estado final estable.
      this.pendingFilterSearch = { fullUrl: fullUrl };

      if (this.filterSearchDebounceTimer) {
        clearTimeout(this.filterSearchDebounceTimer);
      }

      this.filterSearchDebounceTimer = setTimeout(() => {
        this.filterSearchDebounceTimer = null;
        const pending = this.pendingFilterSearch || {};
        this.pendingFilterSearch = null;
        this.flushFilterOptions(pending.fullUrl);
      }, 250);
    },
    flushFilterOptions(fullUrl){
      // LBT-1395 (tester finding 1, round 3): capture whether this is the first
      // flush after boot. The boot flush always fires because sendFilterOptions
      // is called by updateVehiclesCount during entryPoint, and the debounce
      // setTimeout defers the actual push to a later tick. We let the legacy
      // lbxFilterSearch event emit as before (downstream GTM still listens for
      // it on every flush), but we suppress the new lbx_ui_interaction so the
      // boot does not look like a user-initiated filter change. The lbx_page_view
      // emitted by srpReady() already carries the initial filter state.
      const isBootFlush = !this.lbxBootDone;
      this.lbxBootDone = true;

      const filteredOptions = Object.keys(this.selected).reduce((acc, key) => {
        if (this.selected[key].length > 0) {
          acc[key] = this.selected[key].join(", ").toUpperCase();
        }
        return acc;
      }, {});

      // Normaliza los valores solo para comparación: trata guiones y espacios
      // como equivalentes (ej. "BRONCO-SPORT" === "BRONCO SPORT").
      const normalizeForCompare = (obj) => Object.keys(obj).reduce((acc, key) => {
        acc[key] = String(obj[key]).replace(/[-\s]+/g, ' ').trim();
        return acc;
      }, {});

      const normalizedNew = normalizeForCompare(filteredOptions);
      const normalizedLast = normalizeForCompare(this.lastFilteredOptions || {});

      // LBT-1602 (QA 10e): clearing every filter used to report nothing at all.
      //
      // The two conditions below used to be nested the other way round: the
      // first branch required the state to have CHANGED and to be non-empty,
      // and the cleared report lived in the branch for a state that had NOT
      // changed. Clearing is a change, and it lands on an empty state, so it
      // fell between them — no lbx_ui_interaction, and no legacy
      // lbxFilterSearch either, which meant the downstream GTM lost it too.
      // Reproduced from a filtered URL: 88 vehicles to 220, zero pushes.
      //
      // Reading them as two independent facts fixes it. The empty branch now
      // covers both the clear and the boot flush it already handled, and the
      // latch is what keeps it to one report: without it, every later flush on
      // a still-empty state would announce the same clear again.
      const filtersChanged = JSON.stringify(normalizedNew) !== JSON.stringify(normalizedLast);
      const filtersEmpty = Object.keys(filteredOptions).length === 0;

      if (filtersChanged && !filtersEmpty) {
        {
          if(!fullUrl){
            fullUrl = window.location.href;
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'url': fullUrl,
          'event': 'lbxFilterSearch',
          'filter': filteredOptions
          });

          // LBT-1603 (Q4): report the state on EVERY flush, boot ones included.
          // lbx_srp_ready only fires once the applied filters match what the URL
          // asked for, and at boot they often do not yet — a location filter
          // taken from the URL lands a beat later, which is what made it report
          // as null (H8) and what made a multi-filter URL report the count of a
          // partially applied set (H9). The call is idempotent: it returns
          // immediately once the event has fired.
          if (window.LBX && window.LBX.track && typeof window.LBX.track.srpReady === 'function') {
            const readyCount = this.filteredInventory ? this.filteredInventory.length : null;
            window.LBX.track.srpReady(this.lbxFilterState(), readyCount);
          }

          // LBT-1395: push lbx_ui_interaction alongside (Phase 1 migration).
          // Tester finding 1 (round 3): only emit on user-initiated changes.
          if (!isBootFlush && window.LBX && window.LBX.track && typeof window.LBX.track.srpFilterChange === 'function') {
            const diff = diffLastFilter(normalizedLast, normalizedNew);
            const count = this.filteredInventory ? this.filteredInventory.length : null;
            if (diff && diff.removed) {
              // Removing a chip or unticking a value empties the control that
              // held it, which is the spec's 'clear' ("input or filter emptied,
              // reverting the state it controlled") and carries no element_text,
              // because an emptied control has none. This used to go out as
              // 'select' with the invented label 'removed:model' (conformance
              // audit D2, 2026-10-22) -- the same shape the spec owner rejected
              // for the search box's 'cleared'. The filter block alongside says
              // what remains selected.
              window.LBX.track.srpFilterChange(this.lbxFilterState(), count, null, { element_action: 'clear' });
            } else {
              window.LBX.track.srpFilterChange(this.lbxFilterState(), count, diff ? diff.added : null);
            }
          }

          this.lastFilteredOptions = Object.keys(filteredOptions).reduce((acc, key) => {
            acc[key] = filteredOptions[key].toUpperCase(); // Convertir a mayúsculas
            return acc;
          }, {});

          // A selection is on again, so the next clear is a new one to report.
          this.lbxClearedReported = false;
        }
      } else if (filtersEmpty && !this.lbxClearedReported) {
        {
          if(!fullUrl){
            fullUrl = window.location.href;
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'url': fullUrl,
          'event': 'lbxFilterSearch',
          'filter': {condition: this.gutembergOptions.status}
          });

          // LBT-1395: push lbx_ui_interaction alongside (filters cleared case).
          // Same boot guard as above.
          //
          // LBT-1602 (QA 10e): this used to pass 'cleared' as the changed value,
          // which lands in element_text and leaves element_action on its
          // default, 'select'. That is the exact shape the spec owner rejected
          // for the search box: element_text is defined as the element's VISIBLE
          // text, and 'cleared' is a label we invented, so grouping a report by
          // it showed "cleared" as though someone had chosen a filter by that
          // name — while the action claimed a selection had been made. 'clear'
          // was added to the action enum for this (spec v2.1, 2026-08-21); the
          // search box was moved onto it and this sibling path was left behind.
          if (!isBootFlush && window.LBX && window.LBX.track && typeof window.LBX.track.srpFilterChange === 'function') {
            const count = this.filteredInventory ? this.filteredInventory.length : null;
            window.LBX.track.srpFilterChange(this.lbxFilterState(), count, null, { element_action: 'clear' });
          }

          this.lastFilteredOptions = {condition: this.gutembergOptions.status.toUpperCase()};
          this.lbxClearedReported = true;
        }
      }

      // Local helper: what changed between two filter snapshots.
      //
      //   { added: 'RAM' }   a value was selected; the value itself goes to
      //                      element_text ("the filter value selected")
      //   { removed: true }  one or more values went away and nothing arrived:
      //                      a 'clear' of the control that held them
      //   null               nothing changed
      //
      // Values are compared as sets of the comma-joined entries, not as whole
      // strings: adding RAM to JEEP used to report "JEEP, RAM" as the selected
      // value, and unticking RAM reported "JEEP" as though it had just been
      // chosen. A removal is only a removal when no value was added in the same
      // flush -- a swap reports the value that arrived.
      function diffLastFilter(prev, next) {
        prev = prev || {};
        next = next || {};
        const split = (v) => String(v || '').split(',').map((s) => s.trim()).filter(Boolean);
        const keys = Object.keys(Object.assign({}, prev, next));
        let removed = false;
        for (const k of keys) {
          const before = split(prev[k]);
          const after = split(next[k]);
          const added = after.filter((v) => before.indexOf(v) === -1);
          if (added.length) return { added: added.join(',') };
          if (before.some((v) => after.indexOf(v) === -1)) removed = true;
        }
        return removed ? { removed: true } : null;
      }
    },
    recalculateRangesFromInventory() {
      // Recalculate min/max price and mileage from the full initialResultset
      // This is needed when condition filter is cleared, as the initial values
      // were calculated only for the pre-filtered condition (e.g., only New vehicles)
      if (!this.initialResultset || this.initialResultset.length === 0) return;

      let maxPrice = 0;
      let maxMileage = 0;

      this.initialResultset.forEach(item => {
        const price = item.price || 0;
        const mileage = item.mileage || 0;

        if (price > maxPrice) maxPrice = price;
        if (mileage > maxMileage) maxMileage = mileage;
      });

      // Update the min/max values - min always starts at 0
      this.minPrice = 0;
      this.maxPrice = maxPrice;
      this.minMileage = 0;
      this.maxMileage = maxMileage;

      // Reset ranges to the new full range
      this.priceRange = [0, maxPrice];
      this.mileageRange = [0, maxMileage];
    },
    clearParameters(url, keepSort = true) {
      const hasNew = url.includes('/new/') || url.includes('/neufs/');
      const hasConditionNew = url.includes('/condition/new/');

      const isNewUrl = hasNew && !hasConditionNew;

      let baseUrl;

      // For child SRP pages (e.g. slug = 'new-parent/bronco'), use slug directly
      // to preserve the full hierarchical path. The regex only captures the first
      // URL segment, which would incorrectly strip the child page slug.
      if (this.slug && this.slug.includes('/')) {
        baseUrl = `/${this.slug}/`;
      } else {
        const baseMatch = url.match(isNewUrl ? /(\/(?:new|neufs)\/[^/]+\/)/ : /(\/[^/]+\/)/);

        if (!baseMatch) {
          return `/${this.slug}/`;
        }

        baseUrl = baseMatch[1];
      }

      const sortBy = url.match(/sort_by\/[^/]+/);
      const sortOrder = url.match(/sort_order\/[^/]+/);

      let resultUrl = baseUrl;

      if (sortBy && sortOrder && keepSort) {
        resultUrl += `${sortBy[0]}/${sortOrder[0]}/`;
      }

      return resultUrl;
    },
    restoreUrl() {
      this.buildUrl(false);
      history.replaceState({}, null, this.urlToGo);
    },
    clear() {
      this.clearing = true;
      // Drop filter_vin from the URL so restoreUrl() (which preserves window.location.search
      // verbatim) won't re-attach it. The spa-inventory side reads filter_vin live from the
      // URL, so this also stops the sticky re-injection there.
      try {
        var _params = new URLSearchParams(window.location.search);
        if (_params.has('filter_vin')) {
          _params.delete('filter_vin');
          var _qs = _params.toString();
          history.replaceState({}, null, window.location.pathname + (_qs ? '?' + _qs : ''));
        }
      } catch (e) {}
      EventBus.$emit('CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION');
      EventBus.$emit('CLEAR_ALL_SEARCHABLES_SELECTION');
      this.stockNumber = "";
      this.filterValue = "";
      this.lastTrackedSearchValue = "";
      if (this.$refs.toggleListSort) this.$refs.toggleListSort.clear();
      this.dryweightRange = [this.minDryweight, this.maxDryweight];
      this.grossweightRange = [this.minGrossweight, this.maxGrossweight];
      this.sleepcapacityRange = [this.minSleepcapacity, this.maxSleepcapacity];
      this.mileageRange = [this.minMileage, this.maxMileage];
      this.priceRange = [this.minPrice, this.maxPrice];
      this.carprooflinkRange = [this.minCarprooflink, this.maxCarprooflink];
      this.paymentRange = [this.minPayment, this.maxPayment];
      this.tags = [];
      this.payloadtags = [];
      this.selected = this.clearSelected();
      //this.updateRangeLimits();
      this.pivotList = [];
      this.updateVehiclesCount();
      this.restoreUrl();

      // Restaurar visibilidad de model después de limpiar
      // trim se mantiene deshabilitado hasta que se seleccione un model
      if (this.$refs.modelToggleList) {
        this.$refs.modelToggleList.show = true;
        this.$refs.modelToggleList.enable = true;
      }
      if (this.$refs.trimToggleList) {
        this.$refs.trimToggleList.show = false;
        this.$refs.trimToggleList.enable = false;
        this.pleaseSelectAModel = true;
      }

      this.clearing = false;

      // LBT-1602 (QA 10e): report the clear, once, now that it has settled.
      //
      // Everything above runs with `clearing` raised, and buildUrl() skips
      // sendFilterOptions() while it is — which is what stops the cascade of
      // resetting toggle lists from emitting a flush each. The side effect was
      // that the clear itself was never reported in ANY event: no
      // lbx_ui_interaction, and no legacy lbxFilterSearch either, so the
      // downstream GTM lost it too. Measured from a filtered URL: 88 vehicles
      // to 220, zero pushes.
      //
      // Sending once here, with the flag down, gives the final state the one
      // flush it deserves. No URL is passed on purpose: restoreUrl() has
      // already rewritten the address bar, so flushFilterOptions' own fallback
      // to window.location.href is the cleared URL, and the 250ms debounce
      // still collapses this with anything the cascade left queued.
      this.sendFilterOptions();
    },
    clearPrice() {
      this.priceRange = [this.minPrice, this.maxPrice];
    },
    clearMileage() {
      this.mileageRange = [this.minMileage, this.maxMileage];
    },
    clearCarprooflink() {
      this.carprooflinkRange = [this.minCarprooflink, this.maxCarprooflink];
    },
    clearPayment() {
      this.paymentRange = [this.minPayment, this.maxPayment];
    },
    updateVehiclesCount() {
      this.sendSignalToInventory();
      this.filteredInventory = EventBus.postFilterInventory(this.initialResultset, this.filteringPayload);
      this.updateOptions();
      this.vehiclesCount = this.filteredInventory.length;
      this.updateRangeLimits();

      if(this.minPayment == 0 && this.maxPayment == 0){
        this.getPaymentRange();
      }
    },
    onSearchInput() {
      // Actualizar el conteo inmediatamente
      this.updateVehiclesCount();

      // Limpiar el timer anterior si existe
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      // Crear nuevo timer para enviar analytics después de 500ms sin teclear
      this.searchDebounceTimer = setTimeout(() => {
        this.trackSearchAnalytics();
      }, 500);
    },
    trackSearchAnalytics() {
      // Solo enviar si:
      // 1. Hay contenido en el input
      // 2. El valor es diferente al último rastreado
      if (!this.filterValue || this.filterValue.trim() === '') {
        // LBT-1602 (M2): clearing the box is a filter change too. Without this
        // the dataLayer keeps reporting the narrowed state while the shopper is
        // back to the full list. Guarded on there having BEEN a search, so an
        // empty input can never emit anything on its own.
        //
        // It reports as element_action 'clear' with no element_text. This first
        // shipped as action 'search' with element_text 'cleared', which the spec
        // owner caught: element_text is defined as the element's VISIBLE text,
        // and 'cleared' is a label we invented — clearing a field has no text of
        // its own. Grouping a report by element_text showed "cleared" as though
        // someone had searched for that word. 'clear' was added to the enum
        // instead (spec v2.1, 2026-08-21).
        if (this.lastTrackedSearchValue) {
          this.lbxTrackSearch(null, 'clear');
        }
        this.lastTrackedSearchValue = '';
        return;
      }

      // Evitar enviar el mismo valor múltiples veces
      if (this.filterValue === this.lastTrackedSearchValue) {
        return;
      }

      // Actualizar el último valor rastreado
      this.lastTrackedSearchValue = this.filterValue;

      // LBT-1602 (M2): the inventory search reports as the filter change it is.
      //
      // WHY THIS WAS MISSING, because it is not obvious from here: the facet
      // path emits lbx_ui_interaction from flushFilterOptions, and the keyword
      // search never goes through it — it has its own handler, rewrites the URL
      // with replaceState and re-filters in place, with no page load. So
      // filter_keyword only ever reached the dataLayer on a DIRECT load of a
      // /filter/<term>/ URL, and typing the same search in the page reported
      // nothing at all: the last inventory state stayed the pre-search one,
      // with the pre-search count.
      //
      // The spec's own premise ("the search triggers a full page load, so the
      // value travels on the next page") is true of some entry points and false
      // of this one. Reported to the spec owner alongside this fix.
      this.lbxTrackSearch(this.filterValue);

      // SHIFT DIGITAL EVENTS
      if (document.getElementById("shiftdigital-script") != null) {
        sd('dataLayer', {
          typedSearchContent: this.filterValue.replaceAll(" ", "|"),
          events: 'typedSearch'
        });
        sd('send');
      }
    },
    // LBT-1602 (M2): the keyword search as lbx_ui_interaction. Sends the same
    // 12-field snapshot and result count as a facet change, named
    // element_type 'search' / element_action 'search' per the spec.
    //
    // Rides the caller's existing 500ms debounce and its last-value guard, so a
    // shopper typing "wrangler" reports once, on the settled term, not nine
    // times letter by letter.
    lbxTrackSearch(changedValue, action) {
      if (!window.LBX || !window.LBX.track || typeof window.LBX.track.srpFilterChange !== 'function') {
        return;
      }

      // updateVehiclesCount() has already re-filtered by the time this runs —
      // onSearchInput calls it before starting the debounce — so this is the
      // count the shopper is looking at, not the one from before the search.
      const count = this.filteredInventory ? this.filteredInventory.length : null;

      window.LBX.track.srpFilterChange(this.lbxFilterState(), count, changedValue, {
        element_type: 'search',
        element_name: 'srp_search',
        element_action: action || 'search'
      });
    },
    refreshSliders() {
      Object.keys(this.$refs).forEach(ref => {
        const slider = this.$refs[ref];
    
        if (slider && typeof slider.refresh === 'function') {
          slider.refresh();
          slider.unbindEvents();
          slider.bindEvents();
        }
    
        // Forzar la reasignación de eventos de touch/drag si es necesario
        if (slider && typeof slider.addEventListener === 'function') {
          slider.addEventListener('touchstart', this.handleTouchStart);
          slider.addEventListener('mousedown', this.handleMouseDown);
        }
      });
    },
    updateRangeLimits() {
      //refresh the range limits
      if (this.$refs.minPrice) this.$refs.minPrice.innerHTML = this.formatter(this.priceRange[0]);
      if (this.$refs.maxPrice) this.$refs.maxPrice.innerHTML = this.formatter(this.priceRange[1]);
      if (this.$refs.minPriceMobile) this.$refs.minPriceMobile.innerHTML = this.formatter(this.priceRange[0]);
      if (this.$refs.maxPriceMobile) this.$refs.maxPriceMobile.innerHTML = this.formatter(this.priceRange[1]);

      if (this.$refs.minMileage) this.$refs.minMileage.innerHTML = this.mileageformatter(this.mileageRange[0]);
      if (this.$refs.maxMileage) this.$refs.maxMileage.innerHTML = this.mileageformatter(this.mileageRange[1]);
      if (this.$refs.minMileageMobile) this.$refs.minMileageMobile.innerHTML = this.mileageformatter(this.mileageRange[0]);
      if (this.$refs.maxMileageMobile) this.$refs.maxMileageMobile.innerHTML = this.mileageformatter(this.mileageRange[1]);

      if (this.$refs.minCarprooflink) this.$refs.minCarprooflink.innerHTML = this.carprooflinkformatter(this.carprooflinkRange[0]);
      if (this.$refs.maxCarprooflink) this.$refs.maxCarprooflink.innerHTML = this.carprooflinkformatter(this.carprooflinkRange[1]);
      if (this.$refs.minCarprooflinkMobile) this.$refs.minCarprooflinkMobile.innerHTML = this.carprooflinkformatter(this.carprooflinkRange[0]);
      if (this.$refs.maxCarprooflinkMobile) this.$refs.maxCarprooflinkMobile.innerHTML = this.carprooflinkformatter(this.carprooflinkRange[1]);

      if (this.$refs.minPayment) this.$refs.minPayment.innerHTML = this.formatter(this.paymentRange[0]);
      if (this.$refs.maxPayment) this.$refs.maxPayment.innerHTML = this.formatter(this.paymentRange[1]);
      if (this.$refs.minPaymentMobile) this.$refs.minPaymentMobile.innerHTML = this.formatter(this.paymentRange[0]);
      if (this.$refs.maxPaymentMobile) this.$refs.maxPaymentMobile.innerHTML = this.formatter(this.paymentRange[1]);

    },
    formatter(value) {
      var digits = 0;
      var formatter = this.language == 'fr_CA' ? new Intl.NumberFormat("fr-CA", {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: digits,
      }) : new Intl.NumberFormat("en-CA", {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: digits,
      });
      value = (digits != 0) ? formatter.format(value) : formatter.format(Math.floor(value));

      if (this.language == 'fr_CA') {
        return value;
      }
      else {
        return value;
      }
    },
    mileageformatter(value) {
      const formatter = this.language == 'fr_CA' ? new Intl.NumberFormat("fr-CA", {
        style: 'unit',
        unit: 'kilometer'
      }) : new Intl.NumberFormat("en-CA", {
        style: 'unit',
        unit: 'kilometer'
      });

      return formatter.format(Math.floor(value));
    },
    dryweightformatter(value) {
      return `${value} lbs.`
    },
    sleepcapacityformatter(value) {
      return `${value} Sleeps`
    },
    carprooflinkformatter(value) {
      return `${value} Kgs.`
    },
    isEmpty(val) {
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    },
    filterInventory(makes, models, inventory) {
      var filteredInventory = [];
      Object.values(inventory).forEach(item => {
        var filter = true;
        if (filter && makes.length > 0 &&
          makes.indexOf(toUpper(item.make)) == -1) {
          filter = false
        }
        if (filter && models.length > 0 &&
          models.indexOf(toUpper(item.model)) == -1) {
          filter = false
        }
        if (filter) {
          filteredInventory.push(item);
        }
      })
      return filteredInventory;
    },
    updateOptions() {

      if (this.filteredInventory) {
        if (this.filteredInventory.length > 0) {
          this.options = this.getOptions(this.filteredInventory);
          // Faceted counts: a selected facet must NOT shrink its own option
          // counts to the currently-matching values. Recompute each selected
          // facet over the inventory filtered by every OTHER facet, so the
          // non-selected options keep showing how many vehicles they would add.
          this.applyFacetedCounts();
          this.buildUrl();
          history.replaceState({}, null, this.urlToGo);
        } else {
          this.options = this.clearOptions();

          // A zero-result state is still a state, and it still has to flush.
          //
          // Only the non-empty branch used to reach buildUrl(), which is what
          // schedules sendFilterOptions() -> flushFilterOptions(). So nothing was
          // reported when the inventory came up empty: not the legacy
          // lbxFilterSearch, not the lbx_ui_interaction for the change that
          // produced the empty list (Chrysler + diesel -> 0, silent), and on a
          // landing whose URL filter the dealer cannot satisfy
          // (/new-vehicles/make/honda/) not even the boot flush -- so lbxBootDone
          // stayed false and the shopper's FIRST interaction on that page was
          // swallowed as if it were the boot (post-deploy check, 2026-10-23).
          //
          // buildUrl() alone: the address bar is left as it is. The non-empty
          // branch rewrites it to the resolved state, but an empty result has no
          // resolved state worth writing over what the shopper typed or followed.
          this.buildUrl();
        }

      }
    },
    // Maps each `selected` key (singular) to its `optionsCount`/`options` key
    // (plural), mirroring resolveSelectedSlugs(). Drives applyFacetedCounts().
    facetCountMap() {
      return {
        condition: "conditions",
        year: "years",
        make: "makes",
        model: "models",
        trim: "trims",
        colour: "colours",
        bodystyle: "bodystyles",
        transmission: "transmissions",
        drivetrain: "drivetrains",
        fueltype: "fueltypes",
        enginedisplacement: "enginedisplacements",
        feature: "features",
        status: "status",
        package: "packages",
        seat: "seats",
        location: "locations",
        engine: "engines",
        boxsize: "boxsizes",
      };
    },
    // Per-facet value extractor. Returns the value(s) an item contributes to a
    // given facet's count. MUST stay in sync with the counting rules inside
    // getOptions() — same normalization (toUpperCase, toString, status flags).
    facetValueExtractors() {
      return {
        conditions: (item) => (item.condition ? [item.condition] : []),
        years: (item) => (item.year ? [item.year] : []),
        makes: (item) => (item.make ? [toUpper(item.make)] : []),
        models: (item) => (item.model ? [toUpper(item.model)] : []),
        trims: (item) => (item.trim ? [toUpper(item.trim)] : []),
        colours: (item) =>
          typeof item.exteriorcolor === 'string' && item.exteriorcolor ? [item.exteriorcolor.toUpperCase()] : [],
        bodystyles: (item) => (item.bodystyle ? [item.bodystyle] : []),
        transmissions: (item) =>
          item.transmission ? [item.transmission] : [],
        drivetrains: (item) =>
          item.drivetrain ? [toUpper(item.drivetrain)] : [],
        fueltypes: (item) =>
          item.fueltype ? [toUpper(item.fueltype)] : [],
        enginedisplacements: (item) =>
          item.enginedisplacement ? [item.enginedisplacement.toString()] : [],
        locations: (item) =>
          item.location ? [toUpper(item.location)] : [],
        engines: (item) => (item.engine ? [toUpper(item.engine)] : []),
        boxsizes: (item) => (item.boxsize ? [toUpper(item.boxsize)] : []),
        seats: (item) =>
          item.seats !== undefined && item.seats !== null && item.seats !== ""
            ? [item.seats.toString()]
            : [],
        features: (item) =>
          Array.isArray(item.searchablesarray)
            ? item.searchablesarray.slice()
            : [],
        status: (item) => {
          var s = [];
          s.push(item.incoming ? "INCOMING" : "IN STOCK");
          if (item.special) s.push("SPECIAL");
          if (item.demo) s.push("DEMO");
          if (item.asis) s.push("AS IS");
          if (item.salepending) s.push("SALE PENDING");
          if (item.certified) s.push("CERTIFIED");
          return s;
        },
        packages: (item) => {
          if (
            typeof item.searchables === "undefined" ||
            !item.searchables ||
            item.searchables.length === 0
          )
            return [];
          var regex = new RegExp(this.packageRegex);
          return item.searchables.split(",").filter((p) => p.match(regex));
        },
      };
    },
    // Counts how many vehicles in `inventory` fall under each value of a single
    // facet. Deduplicates per item so multi-value facets (features/packages)
    // count vehicles, not occurrences. Returns a { value: count } map.
    tallyFacetCounts(inventory, optKey) {
      var extractor = this.facetValueExtractors()[optKey];
      if (!extractor) return null;

      var counts = {};
      Object.values(inventory).forEach((item) => {
        var seen = {};
        extractor(item).forEach((value) => {
          if (value === undefined || value === null || value === "") return;
          if (seen[value]) return;
          seen[value] = true;
          counts[value] = (counts[value] || 0) + 1;
        });
      });
      return counts;
    },
    // For every facet that has an active selection, recompute its counts over
    // the inventory filtered by all the OTHER facets (i.e. excluding itself).
    // Facets without a selection are left untouched: filteredInventory already
    // gives them the correct facet-aware count since they don't exclude
    // themselves. Only runs for selected facets (typically 1-3), so it's cheap.
    applyFacetedCounts() {
      var map = this.facetCountMap();

      Object.keys(map).forEach((selKey) => {
        var optKey = map[selKey];
        var selectedValues = this.selected[selKey];
        if (!selectedValues || selectedValues.length === 0) return;

        // Clone the payload but blank out this facet so its own selection does
        // not constrain its counts.
        var clonedSelected = Object.assign({}, this.selected);
        clonedSelected[selKey] = [];
        var payload = Object.assign({}, this.filteringPayload, {
          selected: clonedSelected,
        });

        var subset = EventBus.postFilterInventory(
          this.initialResultset,
          payload
        );
        var counts = this.tallyFacetCounts(subset, optKey);
        if (counts) this.optionsCount[optKey] = counts;
      });
    },
    sendSignalToInventory() {
      // Emit instance-specific event if instanceId exists, otherwise global
      const filterEvent = this.instanceId ? 'filterInventory_' + this.instanceId : 'filterInventory';
      EventBus.$emit(filterEvent, this.filteringPayload);
      this.validatePriceRange();
    },
    validatePriceRange() {

      var payloadPrice = {
        "component": "priceRange",
        "selected": "Price $" + this.filteringPayload.priceRange[0] + " - $" + this.filteringPayload.priceRange[1],
        "status": true
      }

      var payloadMileage = {
        "component": "mileageRange",
        "selected": "Mileage " + this.filteringPayload.mileageRange[0] + "km - " + this.filteringPayload.mileageRange[1] + "km",
        "status": true
      }

      var payloadCarprooflink = {
        "component": "carprooflinkRange",
        "selected": "Towing Capacity " + this.filteringPayload.carprooflinkRange[0] + "Kgs. - " + this.filteringPayload.carprooflinkRange[1] + "Kgs.",
        "status": true
      }

      var payloadPayment = {
        "component": "paymentRange",
        "selected": "Payment $" + this.filteringPayload.paymentRange[0] + " - $" + this.filteringPayload.paymentRange[1],
        "status": true
      }  

      if ((this.filteringPayload.priceRange[0] + this.filteringPayload.priceRange[1]) != (this.minPrice + this.maxPrice)) {
        if (!this.tags.includes(payloadPrice.selected)) {
          if (payloadPrice.status) {

            for (var i = 0; i < this.tags.length; i++) {
              if (this.tags[i].includes("Price ")) {
                this.tags.splice(i, 1);
                this.payloadtags.splice(i, 1);
              }
            }
            this.tags.push(payloadPrice.selected);
            this.payloadtags.push(payloadPrice);
          }
        }
      }

      if ((this.filteringPayload.carprooflinkRange[0] + this.filteringPayload.carprooflinkRange[1]) != (this.minCarprooflink + this.maxCarprooflink)) {
        if (!this.tags.includes(payloadCarprooflink.selected)) {
          if (payloadCarprooflink.status) {

            for (var i = 0; i < this.tags.length; i++) {
              if (this.tags[i].includes("Towing ")) {
                this.tags.splice(i, 1);
                this.payloadtags.splice(i, 1);
              }
            }
            this.tags.push(payloadCarprooflink.selected);
            this.payloadtags.push(payloadCarprooflink);
          }
        }
      }

      if ((this.filteringPayload.paymentRange[0] + this.filteringPayload.paymentRange[1]) != (this.minPayment + this.maxPayment)) {
        if (!this.tags.includes(payloadPayment.selected)) {
          if (payloadPayment.status) {

            for (var i = 0; i < this.tags.length; i++) {
              if (this.tags[i].includes("Payment ")) {
                this.tags.splice(i, 1);
                this.payloadtags.splice(i, 1);
              }
            }
            this.tags.push(payloadPayment.selected);
            this.payloadtags.push(payloadPayment);
          }
        }
      }

      if ((this.filteringPayload.mileageRange[0] + this.filteringPayload.mileageRange[1]) != (this.minMileage + this.maxMileage)) {
        if (!this.tags.includes(payloadMileage.selected)) {
          if (payloadMileage.status) {

            for (var i = 0; i < this.tags.length; i++) {
              if (this.tags[i].includes("Mileage ")) {
                this.tags.splice(i, 1);
                this.payloadtags.splice(i, 1);
              }
            }
            this.tags.push(payloadMileage.selected);
            this.payloadtags.push(payloadMileage);
          }
        }
      }

    },
    makeChanged(selected, clear = true) {
      if (selected.length == 0) {
        // Solo ocultar modelo si NO estamos limpiando todos los filtros
        if (!this.clearing) {
          this.$refs.modelToggleList.show = false;
        }
        this.$refs.modelToggleList.enable = true;

        this.postOptions.models = [];
        this.postOptions.trims = [];
      }
      else {
        if (this.$refs.modelToggleList && clear)
          this.$refs.modelToggleList.clearSelection();

        if(this.urlParams.makes === undefined)
          this.$refs.modelToggleList.show = true;

        this.$refs.modelToggleList.enable = true;
        var options = this.getOptions(this.filteredInventory);
        this.postOptions.models = options.models;
      }
    },
    modelChanged(selected) {
      if (selected.length == 0) {
        // Solo ocultar/deshabilitar trim si NO estamos limpiando todos los filtros
        if (!this.clearing) {
          this.$refs.trimToggleList.show = false;
          this.$refs.trimToggleList.enable = false;
          this.pleaseSelectAModel = true;
        }
        this.$refs.trimToggleList.clearSelection();
        this.removeComponentTypeTags("trim");
      }
      else {
        if(this.urlParams.models === undefined)
          this.$refs.trimToggleList.show = true;

        this.$refs.trimToggleList.enable = true;
        this.pleaseSelectAModel = false;
      }
    },
    updateTags(payload) {
      const selectedLower = String(payload.selected).toLowerCase();
      const exists = this.tags.some(t => String(t).toLowerCase() === selectedLower);
      if (!exists) {
        if (payload.status) {
          this.tags.push(payload.selected.toLowerCase());
          this.payloadtags.push(payload);
        }
      } else {
        if (!payload.status) {
          for (var i = 0; i < this.tags.length; i++) {
            if (String(this.tags[i]).toLowerCase() == selectedLower) {
              this.tags.splice(i, 1);
              this.payloadtags.splice(i, 1);
            }
          }

        }
      }
    },
    checkTagType(item) {
      if (item === '1') {
        return "Demo";
      } else {
        return item;
      }
    },
    removeConditionTag(item) {
      for (var i = 0; i < this.tags.length; i++) {
        if (this.tags[i].toUpperCase() == item.toUpperCase()) {
          this.tags.splice(i, 1);
          this.payloadtags.splice(i, 1);
        }
      }
      this.updateVehiclesCount();
    },
    removeComponentTypeTags(componentType) {
      for (var i = 0; i < this.payloadtags.length; i++) {
        if (this.payloadtags[i].component == componentType) {
          this.payloadtags.splice(i, 1);
          this.tags.splice(i, 1);
          i--;
        }
      }
    },
    normalizeString(str) {
      return str.replace(/-/g, '').replace(/\s+/g, '').toLowerCase();
    },
    searchVehicle(query, vehicleList) {
      const normalizedQuery = this.normalizeString(query);
      return vehicleList.some(vehicle => this.normalizeString(vehicle) === normalizedQuery);
    },
    searchVehicleIndex(query, vehicleList) {
      const normalizedQuery = this.normalizeString(query);
    
      return vehicleList.findIndex(vehicle => this.normalizeString(vehicle) === normalizedQuery);
    },
    removeVehicle(query, vehicleList) {
      const index = this.searchVehicleIndex(query, vehicleList);
      if (index !== -1) {
        vehicleList.splice(index, 1);
      }
    },
    removeTag(item){
      var component;
      var payload;

      if(item)
      for(var i = 0; i < this.tags.length; i++) {
        if(this.tags[i] == item){
          this.tags.splice(i, 1);
          component = this.payloadtags[i].component;
          this.payloadtags.splice(i, 1);
        }
      }
   
      if(item && component){
        if(component == "priceRange"){
          this.priceRange = [this.minPrice,this.maxPrice];
          payload={'component':component, 'selected':[]}
        }else if(component == "mileageRange"){
          this.mileageRange = [this.minMileage,this.maxMileage];
          payload={'component':component, 'selected':[]}
        }else if(component == "carprooflinkRange"){
          this.carprooflinkRange = [this.minCarprooflink,this.maxCarprooflink];
          payload={'component':component, 'selected':[]}
        } else if(component == "paymentRange"){
          this.paymentRange = [this.minPayment,this.maxPayment];
          payload={'component':component, 'selected':[]}
        }else{
          if(this.searchVehicle(item, this.selected[component]))
            this.removeVehicle(item, this.selected[component]);
  
          payload = {'component':component, 'selected':this.selected[component]}
        }    
        
        this.pivoting(payload); //With this reorder the pivot list to refresh the options
        //this.updateVehiclesCount();
        // with this te TRim select list is disabled when remove model filter. //By Pablo May-23
        if(component == "model") {
          this.modelChanged(this.selected[component]);    
        }
        if(component == "make") {
          this.makeChanged(this.selected[component]);
        }
        payload = { 'component': component, 'selected': this.selected[component] }

        // LBT-1461: removing a feature via its tag pill (or the automatic
        // removeTagNull) mutates selected.feature here without going through a
        // child toggle, so the bar/vertical local copies must be re-synced.
        if (component === "feature") {
          this.broadcastFeatureSelection();
        }
      }
    },
    removeAllTags() {
      this.initialZero = false;
      this.tags = [];
      this.payloadtags = [];
      this.clear();
    },
    removeTagNull(component){
      
      var components = component === 'status' ? component : `${component}s`;
      var optionsAvalaible = this.options[components];
      var tagFound = false;

      for (var i = 0; i < this.payloadtags.length; i++) {
        if (this.payloadtags[i].component == component) {
          tagFound = false;
          for(var j = 0; j < optionsAvalaible.length; j++) {
            if(this.payloadtags[i].selected.toUpperCase().replace(/[\s-]/g, "") == optionsAvalaible[j].toUpperCase().replace(/[\s-]/g, "")){
              tagFound = true;
            }
          }
          if (!tagFound) {
            this.removeTag(this.payloadtags[i].selected);
          }
        }
      }

    },
    broadcastFeatureSelection() {
      // LBT-1461: the horizontal Popular Features bar (feature-quick-bar) and the
      // vertical "Popular Features" group keep independent local `selected` copies
      // mirrored via SYNC_FEATURE_SELECTION. Toggles in either child already emit
      // it, but parent-side mutations (tag-pill removal, and the automatic
      // removeTagNull when an option leaves the inventory after a zero-result
      // filter) do not — so re-broadcast the authoritative feature selection here
      // to keep both children in sync. source:'parent' never matches a child _uid,
      // and children do not re-emit on receive, so there is no echo loop.
      EventBus.$emit('SYNC_FEATURE_SELECTION', {
        source: 'parent',
        selected: Array.isArray(this.selected.feature) ? this.selected.feature.slice() : [],
      });
    },
    updateChecked(payload) {
      if (this.vehiclesCount > 0 || Object.keys(payload.selected).length > 0 || !this.initialZero) {

        this.removeTagNull(payload.component);
        this.selected[payload.component] = payload.selected

        // Sync tags for this component
        // 1. Remove all existing tags for this component
        for (var i = 0; i < this.payloadtags.length; i++) {
          if (this.payloadtags[i].component === payload.component) {
            this.payloadtags.splice(i, 1);
            this.tags.splice(i, 1);
            i--;
          }
        }

        // 2. Add current selections as tags (avoiding case-insensitive duplicates)
        if (Array.isArray(payload.selected)) {
          payload.selected.forEach(item => {
            const exists = this.tags.some(t => String(t).toLowerCase() === String(item).toLowerCase());
            if (!exists) {
              this.tags.push(item);
              this.payloadtags.push({
                component: payload.component,
                selected: item,
                status: true
              });
            }
          });
        }

        // When condition filter is cleared, recalculate min/max from full inventory
        // This is needed because the initial min/max were calculated only for the pre-filtered condition
        if (payload.component === 'condition' && payload.selected.length === 0) {
          this.recalculateRangesFromInventory();
        }

        this.pivoting(payload);
        if (payload.component == 'model') {
          this.modelChanged(payload.selected);
        }
        if (payload.component == 'make') {
          this.makeChanged(payload.selected);
        }

        // LBT-1461: keep the horizontal bar and vertical group aligned after any
        // selection change (covers the auto removeTagNull on zero-result filters).
        this.broadcastFeatureSelection();
      }
    },
    search() {
      if (this.vehiclesCount > 0) {
        this.buildUrl();
        this.setSessionStorage();
        window.location.href = this.urlToGo;
      }
    },
    pivoting(payload) {
      var component = `${payload.component}s`;
      var index = this.pivotList.indexOf(component);
      if (payload.selected.length == 0 && index != -1)
        this.pivotList.splice(index, 1);
      else if (payload.selected.length > 0 && index == -1)
        this.pivotList.push(component);

      this.updateVehiclesCount();

    },
    string_contains_value(text, filter) {
      var array = filter.toLowerCase().split("_");
      var total_words = array.length;
      var vehicle = text.split(' ').map((item) => {
        return item.toLowerCase();
      })
      var total_coincidences = 0;
      array.forEach((item) => {
        var total_i = vehicle.filter((span) => {
          return span.includes(item);
        }).length;

        var total_p = vehicle.filter((span) => {
          return span.replace(/-/g, '').includes(item.replace(/-/, ''));
        }).length;

        if (total_i > 0 || total_p > 0)
          total_coincidences++;
      })

      if (total_words == total_coincidences) {
        return true;
      }
      else {
        return false;
      }
    },
    getSelectedFromSessionStorage() {
      return JSON.parse(sessionStorage.getItem('selected'));
    },
    setSessionStorage() {
      sessionStorage.clear();
      sessionStorage.setItem('slug', this.slug);
      sessionStorage.setItem('selected', JSON.stringify(this.selected))
    },
    searchStatusInInventory(status){
      var inventory = this.initialResultset;
      var total = 0;
      inventory.forEach((item) => {
        if(status == 'certified' && item.certified)
          total++;
        else if(status == 'demo' && item.demo)
          total++;
        else if(status == 'asis' && item.asis)
          total++;
        else if(status == 'salepending' && item.salepending)
          total++;
        else if(status == 'special' && item.special)
          total++;
        else if(status == 'new' && item.condition == 'New')
          total++;
        else if(status == 'used' && item.condition == 'Used')
          total++;
      })

      return total;
    }
  },
  computed: {
    initialMakes() {
      return this.urlParams.makes || [];
    },
    initialLots() {
      return this.urlParams.lots || [];
    },
    initialModels() {
      return this.urlParams.models || [];
    },
    initialTrims() {
      return this.urlParams.trims || [];
    },
    initialColours() {
      return this.urlParams.color || [];
    },
    initialBodystyles() {
      return this.urlParams.bodystyles || [];
    },
    initialFueltypes() {
      return this.urlParams.fueltypes || [];
    },
    initialConditions() {
      return this.urlParams.conditions || [];
    },
    initialYears() {
      return this.urlParams.years || [];
    },
    initialSalependings() {
      return this.urlParams.salependings || [];
    },
    initialDemos() {
      return this.urlParams.demos || [];
    },
    initialAsis() {
      return this.urlParams.asiss || [];
    },
    initialCertifieds() {
      return this.urlParams.certifieds || [];
    },
    initialSpecials() {
      return this.urlParams.specials || [];
    },
    initialStocks() {
      return this.urlParams.stocks || [];
    },
    initialFeatures() {
      return this.urlParams.searchables || [];
    },
    initialEnginedisplacements() {
      return this.urlParams.enginedisplacements || [];
    },
    initialPackages() {
      return this.urlParams.package || [];
    },
    initialLocations() {
      return this.urlParams.locations || [];
    },
    initialEngines() {
      return this.urlParams.engines || [];
    },
    initialDrivetrains() {
      return this.urlParams.drivetrains || [];
    },
    initialBoxsizes() {
      return this.urlParams.boxsizes || [];
    },
    initialTransmissions() {
      return this.urlParams.transmissions || [];
    },
    initialStatus() {
      return this.urlParams.status || [];
    },
    initialTypes() {
      return this.urlParams.types || [];
    },
    initialSubTypes() {
      return this.urlParams.types || [];
    },
    initialProductlines() {
      return this.urlParams.productlines || [];
    },
    initialOutsideLengths() {
      return this.urlParams.outsidelength || [];
    },
    initialFloorPlans() {
      return this.urlParams.floorplans || [];
    },
    initialSeats() {
      return this.urlParams.seats || [];
    },
    filteringPayload() {
      return {
        stockNumber: this.stockNumber,
        mileageRange: this.mileageRange,
        priceRange: this.priceRange,
        carprooflinkRange: this.carprooflinkRange,
        paymentRange: this.paymentRange,
        dryweightRange: this.dryweightRange,
        grossweightRange: this.grossweightRange,
        sleepcapacityRange: this.sleepcapacityRange,
        filterValue: this.filterValue,
        selected: this.selected,
        minMileage: this.minMileage,
        maxMileage: this.maxMileage,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        minCarprooflink: this.minCarprooflink,
        maxCarprooflink: this.maxCarprooflink,
        minPayment: this.minPayment,
        maxPayment: this.maxPayment,
        minDryweight: this.minDryweight,
        maxDryweight: this.maxDryweight,
        minGrossweight: this.minGrossweight,
        maxGrossweight: this.maxGrossweight,
        minSleepcapacity: this.minSleepcapacity,
        maxSleepcapacity: this.maxSleepcapacity,
        paymentFrequency: this.paymentFrequency,
        page: 1,
      }
    }
  },
  watch: {
    priceRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount();
      if (this.priceRange[0] == this.priceInitialRange[0] && this.priceRange[1] == this.priceInitialRange[1]) {
        //* Buscar el tag que incluya "price"
        const priceTag = this.tags.find(tag => tag.toLowerCase().includes('price'));
        if (priceTag) {
          this.removeTag(priceTag);
        }
      }
    },
    mileageRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount();
      if (this.mileageRange[0] == this.mileageInitialRange[0] && this.mileageRange[1] == this.mileageInitialRange[1]) {
        //* Buscar el tag que incluya "mileage"
        const mileageTag = this.tags.find(tag => tag.toLowerCase().includes('mileage'));
        if (mileageTag) {
          this.removeTag(mileageTag);
        }
      }
    },
    carprooflinkRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount();
      if (this.carprooflinkInitialRange[0] && this.carprooflinkInitialRange[1] && this.carprooflinkRange[0] == this.carprooflinkInitialRange[0] && this.carprooflinkRange[1] == this.carprooflinkInitialRange[1]) {
        //* Buscar el tag que incluya "carprooflink"
        const carprooflinkTag = this.tags.find(tag => tag.toLowerCase().includes('towing'));
        if (carprooflinkTag) {
          this.removeTag(carprooflinkTag);
        }
      }
    },
    paymentRange(o, n) {    
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount();
      
      if (this.minPayment && this.maxPayment && this.paymentRange[0] == this.minPayment && this.paymentRange[1] == this.maxPayment) {
        //* Buscar el tag que incluya "payment"
        const paymentTag = this.tags.find(tag => tag.toLowerCase().includes('payment'));
        if (paymentTag) {
          this.removeTag(paymentTag);
        }
      }
    },
    dryweightRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount()
    },
    grossweightRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount()
    },
    sleepcapacityRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount()
    },
    loadingInventory(newVal) {
      const eventName = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
      EventBus.$emit(eventName, { loadingInventory: newVal });
    },
    searchOpened(newVal) {
      const eventName = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
      EventBus.$emit(eventName, { searchOpened: newVal });
    },
    selected(newVal) {
      const eventName = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
      EventBus.$emit(eventName, { selected: newVal });
    },
    minPayment(newVal) {
      const eventName = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
      EventBus.$emit(eventName, { minPayment: newVal });
    },
    maxPayment(newVal) {
      const eventName = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
      EventBus.$emit(eventName, { maxPayment: newVal });
    },
    vehiclesCount(newVal) {
      const eventName = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
      EventBus.$emit(eventName, { vehiclesCount: newVal });
    },
    inStockCount(newVal) {
      const eventName = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
      EventBus.$emit(eventName, { inStockCount: newVal });
    },
    incomingCount(newVal) {
      const eventName = this.instanceId ? 'variablesUpdate_' + this.instanceId : 'variablesUpdate';
      EventBus.$emit(eventName, { incomingCount: newVal });
    },
    window: {
      deep: true,
      handler(val) {
        if (val.width <= 1024)
          this.isMobile = true;
        else
          this.isMobile = false;

        if(val.width < 1280)
          this.isTablet = true;
        else
          this.isTablet = false;
      }
    }
  }
}
